<template>
    <v-app id="searchAirbnbAres">
      <v-main>
        <v-container v-show="showParameters" fluid>


          <v-row>
         <v-col cols="2">
            <v-menu
              v-model="dat1menu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
            <template v-slot:activator="{ on }">
            <v-text-field
              v-model="param.van_dat" 
              label="From date"
              v-on="on"
              readonly
            ></v-text-field>
            </template>
            <v-date-picker v-model="param.van_dat2" :first-day-of-week="1" @input="param.van_dat = $moment(param.van_dat2).format('DD-MM-YYYY'); dat1menu = false"></v-date-picker>            
            </v-menu>  
          </v-col>

          <v-col cols="2">
            <v-menu
              v-model="dat2menu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
            <template v-slot:activator="{ on }">
            <v-text-field
              v-model="param.tm_dat" 
              label="Until date"
              v-on="on"
              readonly
            ></v-text-field>
            </template>
            <v-date-picker v-model="param.tm_dat2" :first-day-of-week="1" @input="param.tm_dat = $moment(param.tm_dat2).format('DD-MM-YYYY'); dat2menu = false"></v-date-picker>
            </v-menu>  
          </v-col>

      </v-row>  

 
        <v-row>
            <v-col cols="1">
              <v-btn class="primary ma-0" small @click="getHuov">Search</v-btn>
            </v-col> 
        </v-row>
  
        </v-container>
  
        <v-container fluid>
         <v-btn v-show="!showParameters" class="primary ma-0" small @click="showParameters = true">Show parameters</v-btn> 
  
        <v-row v-if="results" dense no-gutters>
          <v-card class="px-2">
              <v-text-field
              v-model="search"
                label="Search"
                single-line
                hide-details
               >
              </v-text-field>
          
              <v-data-table 
              :items="items" 
              :items-per-page="50" 
              :footer-props="{'items-per-page-options': [50, 100, 200, 300, 500]}"
              :headers="headers"
              :search="search"   
             
              >
              <template v-slot:item="props">
                <tr>   
                <td align="right">{{props.item.line_nr}}</td>    
                <td @click="$router.open('/huov/onHuov/' + props.item.huov_encrid)"><a> {{props.item.huov_code}} </a></td>
                <td>{{props.item.huov_ota_code}}</td>
                <td>{{props.item.hust_code}}</td>
                <td>{{props.item.huov_ann_dat}}</td>
                <td>{{props.item.huov_tm_dat}}</td>
                <td align="right">{{props.item.airbnb}}</td>
                <td align="right">{{props.item.ares}}</td>
                <td align="right">{{props.item.balance}}</td>
                <td>{{props.item.nott_tekst}}</td>
                </tr>
              </template>
              </v-data-table>
          </v-card>
          </v-row>
      </v-container>
      </v-main>
      <navBar title="Ares - Sales partners" :home="true" type="inpt"/>
    </v-app>
  </template>
  
  <script>
  import navBar from "@/components/ui/navbars/navbar.vue";
   export default {
    components: {
      navBar
    },
    data() {
      return {
        results: false,
        dat1menu: false,
        dat2menu: false,
        hulpDate: '',
        showParameters: true,
        items: [],
        param: {},
        
        search: '',
        headers: [
          {text: 'Line nr', value: 'line_nr'},
          {text: 'VFY Booking', value: 'huov_code'},
          {text: 'Airbnb ID', value: 'huov_ota_code'},
          {text: 'Status', value: 'hust_code'},
          {text: 'Cancellation date', value: 'huov_ann_dat'},
          {text: 'Departure date', value: 'huov_tm_dat'},
          {text: 'Airbnb commission', value: 'airbnb'},
          {text: 'Ares commission cal', value: 'ares'},
          {text: 'Balance', value: 'balance'},
          {text: 'Explanation', value: 'nott_tekst'}
        ]
      }  
    },
    created() {
        this.$axios
        .post("ares/json/ares/task/inpt/airbnb/getSearchAirbnbAresParam.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getSearchAirbnbAresParam"
          },
          getSearchAirbnbAresParam: {}
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
             this.param = res.data.getSearchAirbnbAresParam;
          }
        });
  
    },
    methods: {
      /*
      dateToDMY (dat) {
          return dat ? this.$moment(dat).format('DD-MM-YYYY') : ''
        },
       */ 
       getHuov() {
        this.results = true;
        this.showParameters = false;
        this.$axios
          .post("ares/json/ares/task/inpt/airbnb/searchAirbnbAres.p", {
            header: {
              token: this.$session.get("ARES"),
              clientSessionId: this.$session.id(),
              request: "searchAirbnbAres"
            },
            searchAirbnbAres: {
              van_dat: this.param.van_dat,
              tm_dat: this.param.tm_dat
            }
          })
          .then(res => {
            if (res.data.error) {
              console.log(res.data.error);
            } else {
              this.items = res.data.searchAirbnbAres;
            }
          })
          .finally(() => {
            this.loading = false;
          });
      }
    }
  };
  
  </script> 
  